import store from "@/store";
import Vue from "vue";

import CreateProject from "@/views/projects/CreateProject.vue";
import ProjectPage from "@/views/projects/ProjectPage.vue";
import ProjectBase from "@/views/projects/TheBase.vue";

// Products
import MoldedSeatBase from "@/views/products/molded-seat/TheBase.vue";
import MinervaBase from "@/views/products/minerve/TheBase.vue";
import OtnBase from "@/views/products/otn/TheBase.vue";
import LiftBase from "@/views/products/lift/TheBase.vue";
import RetouchingRepairBase from "@/views/products/retouching-repair/TheBase.vue";
import SeatBase from "@/views/products/saddle/TheBase.vue";
import PositioningSeatBase from "@/views/products/positioning-seat/TheBase.vue";
import UpperLimbBase from "@/views/products/upper-limb-orthosis/TheBase.vue";
import LowerLimbBase from "@/views/products/lower-limb-orthosis/TheBase.vue";
import CorsetBase from "@/views/products/corset/TheBase.vue";

import MediasPage from "@/views/medias/MediasPage.vue";
import MediaPage from "@/views/medias/MediaPage.vue";
// import MediaItem from "../../app/medias/media-item/media-item.vue";

import { productsObject } from "@/utils";

async function fetchProduct(routeTo, routeFrom, next) {
  try {
    // Get project from IndexedDB by uuid
    const project = await store.dispatch(
      "projects/getLocalProject",
      routeTo.params.projectUuid
    );

    // Get product action name from object literal
    const getLocalProduct =
      productsObject[routeTo.meta.product_model].getLocalProduct;

    // Get product by uuid
    await store.dispatch(getLocalProduct, project.product_uuid);

    // Load colors
    await store.dispatch("colors/getAllColors");

    // Load dropdowns
    await store.dispatch("dropdowns/getLocalDropdowns");
    next();
  } catch (error) {
    Vue.notify({ group: "main", clean: true });
    Vue.notify({
      group: "main",
      type: "error",
      title:
        error.message ||
        "Une erreur est survenue, veuillez réessayer plus tard.",
      duration: 5000
    });
  }
}

export default [
  // Create page
  {
    path: "create",
    name: "CreateProject",
    component: CreateProject,
    meta: {
      goto: "projects-list-local"
    }
  },

  // View project
  {
    path: ":projectUuid",
    component: ProjectBase,
    children: [
      {
        path: "",
        component: ProjectPage,
        name: "ProjectPage",
        meta: {
          goto: "projects-list-local"
        }
      },

      {
        path: "medias",
        component: MediasPage,
        name: "MediasPage",
        props: true
      },

      {
        path: "medias/:uuid",
        component: MediaPage,
        name: "MediaPage",
        props: true
      },

      {
        path: "neck-brace",
        name: "NeckBraceProduct",
        component: MinervaBase,
        beforeEnter: fetchProduct,
        props: true,
        meta: {
          product_model: "NECK_BRACE"
        }
      },

      {
        path: "molded-seat",
        name: "MoldedSeatProduct",
        component: MoldedSeatBase,
        meta: {
          product_model: "MOLDED_SEAT",
          goback: true // Hamburger menu transforms to goback
        },
        props: true,
        beforeEnter: fetchProduct
      },

      {
        path: "lift",
        name: "LiftProduct",
        component: LiftBase,
        beforeEnter: fetchProduct,
        props: true,
        meta: {
          product_model: "LIFT"
        }
      },

      {
        path: "otn",
        name: "OtnProduct",
        component: OtnBase,
        beforeEnter: fetchProduct,
        props: true,
        meta: {
          product_model: "OTN"
        }
      },

      {
        path: "retouching-repair",
        name: "RetouchingRepairProduct",
        component: RetouchingRepairBase,
        beforeEnter: fetchProduct,
        props: true,
        meta: {
          product_model: "RETOUCHING_REPAIR"
        }
      },
      {
        path: "seat",
        name: "SeatProduct",
        component: SeatBase,
        beforeEnter: fetchProduct,
        props: true,
        meta: {
          product_model: "SEAT"
        }
      },
      {
        path: "positioning-seat",
        name: "PositioningSeatProduct",
        component: PositioningSeatBase,
        beforeEnter: fetchProduct,
        props: true,
        meta: {
          product_model: "POSITIONING_SEAT"
        }
      },
      {
        path: "upper-limb-orthosis",
        name: "UpperLimbProduct",
        component: UpperLimbBase,
        beforeEnter: fetchProduct,
        props: true,
        meta: {
          product_model: "UPPER_LIMB_ORTHOSIS"
        }
      },
      {
        path: "lower-limb-orthosis",
        name: "LowerLimbProduct",
        component: LowerLimbBase,
        beforeEnter: fetchProduct,
        props: true,
        meta: {
          product_model: "LOWER_LIMB_ORTHOSIS"
        }
      },
      {
        path: "corset",
        name: "CorsetProduct",
        component: CorsetBase,
        beforeEnter: fetchProduct,
        props: true,
        meta: {
          product_model: "CORSET"
        }
      }
    ]
  }
];
